module.exports = __webpack_public_path__ + "static/andrew_saloutos-aff83dfdede93cc559adc4410f6afd0a.jpg";